import watchAccreditationRequested from './postAccreditation';

export default [
  watchAccreditationRequested(),
];
